import { EventEmitter } from '@angular/core';
import { getBasicFormatted, PERCENT } from 'Angular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../charts/static/charts/ts/features/bar-chart/bar-chart.component";
const _c0 = a0 => ({ "active": a0 });
function SectorExposureComparisonChart_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 21)(1, "a", 22);
    i0.ɵɵlistener("click", function SectorExposureComparisonChart_li_7_Template_a_click_1_listener() { const view_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onViewChange(view_r2.value)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const view_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, view_r2.value === ctx_r2.selectedExposureView));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", view_r2.label, " ");
} }
function SectorExposureComparisonChart_tr_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "td", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const idx_r5 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-legend-item-title bullet-", idx_r5 + 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r2.formatPercentage(item_r4.data[0]));
} }
/**
 *
 * Exposure Comparison Component with multiple view options.
 *
 */
export class SectorExposureComparisonChart {
    constructor() {
        this.exposureChanged = new EventEmitter();
        this.EXPOSURE_VIEW_OPTIONS = [
            { value: 'sector', label: 'Sector Exposure' },
            { value: 'broad_asset_class', label: 'Broad Asset Class' },
            { value: 'equity_style', label: 'Equity Style' },
        ];
    }
    get tableHeaderLabel() {
        switch (this.selectedExposureView) {
            case 'broad_asset_class':
                return 'Broad Asset Class';
            case 'equity_style':
                return 'Equity Style';
            case 'sector':
            default:
                return 'Sector';
        }
    }
    get chartData() {
        switch (this.selectedExposureView) {
            case 'broad_asset_class':
                return this.exposureChartData.broad_asset_class || [];
            case 'equity_style':
                return this.exposureChartData.equity_style || [];
            case 'sector':
            default:
                return this.exposureChartData.sector || [];
        }
    }
    formatPercentage(value) {
        if (value == null)
            return '--';
        return getBasicFormatted(value, PERCENT, 2);
    }
    onViewChange(exposureViewType) {
        if (exposureViewType !== this.selectedExposureView) {
            this.exposureChanged.emit(exposureViewType);
        }
    }
}
SectorExposureComparisonChart.ɵfac = function SectorExposureComparisonChart_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SectorExposureComparisonChart)(); };
SectorExposureComparisonChart.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SectorExposureComparisonChart, selectors: [["ycn-sector-exposure-comparison"]], inputs: { exposureData: "exposureData", exposureChartData: "exposureChartData", selectedExposureView: "selectedExposureView" }, outputs: { exposureChanged: "exposureChanged" }, standalone: false, decls: 27, vars: 4, consts: [["data-test-id", "overlap-sector-exposure-data", 1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], ["data-tabs-content", "exposureTabs", 1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "divider-horizontal"], [1, "panel-content", "mb-0"], [1, "row", "wide-gutters"], [1, "col-8", "col-lg-9", "pr-20", "divider-vertical"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-wrap"], [1, "chart-canvas", 2, "height", "400px"], [3, "chartData"], [1, "col-4", "col-lg-3", "pl-20"], [1, "table"], [1, "text-thin"], [1, "text-thin", "text-right"], [4, "ngFor", "ngForOf"], [1, "nav-item"], ["href", "#", 1, "nav-link", 3, "click", "ngClass"], [1, "text-right", 3, "textContent"]], template: function SectorExposureComparisonChart_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Exposure Comparison");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "ul", 5);
        i0.ɵɵtemplate(7, SectorExposureComparisonChart_li_7_Template, 3, 4, "li", 6);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8)(10, "div", 9)(11, "div", 10)(12, "div", 11)(13, "div", 12)(14, "div", 13)(15, "div", 14);
        i0.ɵɵelement(16, "ycn-bar-chart", 15);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(17, "div", 16)(18, "table", 17)(19, "thead")(20, "tr")(21, "td", 18);
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "td", 19);
        i0.ɵɵtext(24, "Weight");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(25, "tbody");
        i0.ɵɵtemplate(26, SectorExposureComparisonChart_tr_26_Template, 5, 5, "tr", 20);
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngForOf", ctx.EXPOSURE_VIEW_OPTIONS);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("chartData", ctx.chartData);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.tableHeaderLabel);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.chartData);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i2.BarChartComponent], encapsulation: 2 });
